import { render } from "./SelectAllComponent.vue?vue&type=template&id=70eee96c"
import script from "./SelectAllComponent.vue?vue&type=script&lang=js"
export * from "./SelectAllComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__